<template>
<div class="inventorydynamic">
    <div class="page-title">库存动态</div>
    <div class="page-title-bottom-line"></div>
    <div class="main-content-90">
        <div class="controller-container">
            <div class="controller-content">
                <el-select class="action-select-first" @change="selectInventoryClass" v-model="inventoryClassIndex" placeholder="选择直发库">
                    <el-option v-for="(item, index) in inventoryClassArr" :key="index" :label="item.warehouse_name" :value="item.warehouse_id">
                    </el-option>
                </el-select>
                <el-cascader class="action-select-inventory" placeholder="选择经销商仓库" :filterable="true" :clearable="true" :options="oneLevelInventoryArr" v-model="oneLevelInventory" @change="selectOneLevelInventory">
                </el-cascader>
                <el-cascader class="action-select-inventory" placeholder="选择汽服门店仓库" :filterable="true" :clearable="true" :options="twoLevelInventoryArr" v-model="twoLevelInventory" @change="selectTwoLevelInventory">
                </el-cascader>
            </div>
        </div>
        <div class="table-container">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                <el-table-column align="center" prop="classification" label="分类" min-width="15%">
                </el-table-column>
                <el-table-column align="center" prop="picture" label="商品图片" width="180">
                    <template slot-scope="scope">
                        <img :src="scope.row.picture" height="80" width="72" alt="">
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="name" label="商品名称" min-width="25%">
                </el-table-column>
                <el-table-column align="center" prop="current_nums" label="商品库存" min-width="15%">
                </el-table-column>
                <el-table-column align="center" prop="unit" label="规格" min-width="15%">
                </el-table-column>
                <el-table-column align="center" prop="belong" label="仓库" min-width="15%">
                </el-table-column>
                <el-table-column align="center" prop="status" label="商品库存状态" min-width="15%">
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
export default {
    data() {
        return {
            inventoryClassArr: [],
            inventoryClassIndex: '',
            tableData: [],
            currentWarehouse_id: '',
            oneLevelInventoryArr: [],
            twoLevelInventoryArr: [],
            oneLevelInventory: [],
            twoLevelInventory: [],
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created () {
        this.init();
        this.currentWarehouse_id = 1;
        this.getInventoryTableData(this.currentWarehouse_id, 0);
    },
    methods: {
        changeTableHeaderStyle({row, rowIndex}) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle ({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 6) {
                if(row.status_num == -1) {
                    return 'color: #FF3333;'
                }
                else if(row.status_num == 0) {
                    return 'color: #29bd7f;'
                }
                else if(row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        init() {
            this.axios.get('getwarehouse', {
                params: {
                    user_id: this.user.id, 
                    type: 1
                }
            })
            .then(res => {
                this.inventoryClassArr = res.data.data;

                this.axios.get('getbranchwarehouse', {
                    params: {
                        user_id: this.user.id,
                        branch_type: 1
                    }
                })
                .then(res => {
                    this.oneLevelInventoryArr = res.data.data;

                    this.axios.get('getbranchwarehouse', {
                        params: {
                            user_id: this.user.id,
                            branch_type: 2
                        }
                    })
                    .then(res => {
                        this.twoLevelInventoryArr = res.data.data;
                    })
                })
            })
        },
        getInventoryTableData(warehouse_id, class_id) {
            this.axios.get('obtain_warehouse_info', {
                params: {
                    warehouse_id: warehouse_id,
                    class_id: class_id
                }
            })
            .then(res => {
                this.tableData = res.data.data;
            })
        },
        // 选择直发库
        selectInventoryClass(warehouseId) {
            this.getInventoryTableData(warehouseId, 0)
        },
        // 选择下级仓库结构
        selectOneLevelInventory() {
            this.currentWarehouse_id = this.oneLevelInventory[1];
            this.getInventoryTableData(this.currentWarehouse_id, 0)
        },
        // 选择下2级仓库结构
        selectTwoLevelInventory() {
            this.currentWarehouse_id = this.twoLevelInventory[2];
            this.getInventoryTableData(this.currentWarehouse_id, 0)
        },
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.inventorydynamic {
    background-color: #F9F9F9;
}
.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 161px;
}
.action-select-first {
    margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataBoard/InventoryDynamic.vue